import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Home from './pages/Home/Home';
import AppDetail from './pages/AppDetail/AppDetail';
import Category from './pages/Category/Category';
import Search from './pages/Search/Search';
import AdminLogin from './pages/Admin/Login';
import AdminLayout from './pages/Admin/Layout/AdminLayout';
import Dashboard from './pages/Admin/Dashboard/Dashboard';
import Categories from './pages/Admin/Categories/Categories';
import Apps from './pages/Admin/Apps/Apps';
import Settings from './pages/Admin/Settings/Settings';
import Profile from './pages/Admin/Profile/Profile';
import Ads from './pages/Admin/Ads/Ads';
import CustomLists from './pages/Admin/CustomLists/CustomLists';
import Download from './pages/Download/Download';
import List from './pages/List/List';
import MobileBottomNav from './components/Layout/MobileBottomNav';
import Ad from './components/Ad/Ad';
import { initInterstitialPredConvTracking } from './utils/analytics';
import './App.css';

// 现代化主题配置 - 参考新UI设计
const theme = {
  token: {
    colorPrimary: '#6C5CE7',
    colorSuccess: '#00B894',
    colorWarning: '#FD79A8',
    colorError: '#ff4d4f',
    borderRadius: 12,
    borderRadiusLG: 16,
    colorBgContainer: '#ffffff',
    colorBgLayout: '#F8F9FA',
    colorText: '#2D3436',
    colorTextSecondary: '#636e72',
    fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
  },
  components: {
    Card: {
      borderRadiusLG: 16,
      boxShadowTertiary: '0 4px 12px rgba(0, 0, 0, 0.08)',
    },
    Button: {
      borderRadius: 8,
      borderRadiusLG: 12,
      fontWeight: 500,
    },
    Input: {
      borderRadius: 8,
      borderRadiusLG: 12,
    },
    Layout: {
      headerBg: '#ffffff',
      headerHeight: 72,
    },
  },
};

const FullSiteAd: React.FC = () => {
  const location = useLocation();

  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return <Ad positionName="full_site_ad" />;
};

function App() {
  useEffect(() => {
    initInterstitialPredConvTracking();
  }, []);

  return (
    <ConfigProvider locale={zhCN} theme={theme}>
      <Router>
        <div className="App">
          <FullSiteAd />

          <Routes>
            {/* 前台路由 */}
            <Route path="/" element={<Home />} />
            <Route path="/app/:id" element={<AppDetail />} />
            <Route path="/download/:id" element={<Download />} />
            <Route path="/category/:id" element={<Category />} />
            <Route path="/search/:keyword?" element={<Search />} />
            <Route path="/list/:id" element={<List />} />

            {/* 后台管理路由 */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="categories" element={<Categories />} />
              <Route path="apps" element={<Apps />} />
              <Route path="ads" element={<Ads />} />
              <Route path="custom-lists" element={<CustomLists />} />
              <Route path="settings" element={<Settings />} />
              <Route path="profile" element={<Profile />} />
              <Route index element={<Dashboard />} />
            </Route>
          </Routes>

          {/* 移动端底部导航 */}
          <MobileBottomNav />
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;
